import { EqmInspectSpecDto } from "src/dtos/eqmInspectSpec/eqmInspectSpecDto";

export interface EQM2020_R01Dto extends EqmInspectSpecDto {
	eqmTypeNm?: string;
	eqmStatusTagNm?: string;
	inspectValueNm?: string;
	inspectUseNm?: string;
}

export const defaultEQM2020_R01Dto: EQM2020_R01Dto = {
  	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	eqmType: '',
	inspectCd: '',
	inspectNm: '',
	inspectMethod: '',
	inspectType: '',
	standardValue: '',
	inspectValue: '',
	inspectUse: 'N',
	remark: '',

	inserted: false,
	isModified: false,
	
}